
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../bootstrap';
import 'owl.carousel';
import '../plugins';
import DOMPurify from 'dompurify';
import { Swiper } from 'swiper';
import Toastify from 'toastify-js';

// Make DOMPurify available globally for currency.js and other scripts
window.DOMPurify = DOMPurify;

// Make Swiper available globally for custom.js, currency.js and other scripts
window.Swiper = Swiper;

// Make Toastify available globally for app.blade.php and other scripts
window.Toastify = Toastify;
